import ShopLabel from './shopLabel.vue'
import Shop from './shop.vue'
import Shopper from './shopper.vue'
import ShopInnerLabel from './shopInnerLabel.vue'
import ShopProduct from './shopProduct.vue'

export default {
	ShopLabel,
  Shop,
  Shopper,
  ShopInnerLabel,
  ShopProduct
}



// WEBPACK FOOTER //
// ./src/views/shop/index.js